<template>
  <v-dialog
    v-model="isOpened"
    persistent
    width="680px"
  >
    <v-form @submit.prevent.native="$canWrite && (submit($event))">
      <v-card>
        <v-card-title>
          Nouveau prestataire
          <v-spacer></v-spacer>
          <v-btn icon @click="isOpened = false">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <!-- <v-card-title class="pa-0">
          <v-toolbar color="primary darken-1" dark>
            <v-toolbar-title>Nouveau prestataire</v-toolbar-title>
          </v-toolbar>
        </v-card-title> -->
        <v-card-text class="pa-3">
          <v-row justify="center" align="center">
            <v-col cols="12">
              <v-text-field v-model="name" label="Nom" outlined hide-details required autofocus />
            </v-col>
          </v-row>
          <v-row justify="center" align="center">
            <v-col cols="12">
              <v-text-field v-model="address" label="Adresse" outlined hide-details required />
            </v-col>
          </v-row>
          <v-row justify="center" align="center">
            <v-col cols="4">
              <v-text-field v-model="postalCode" label="Code postal" outlined hide-details required />
            </v-col>
            <v-col cols="8">
              <v-text-field v-model="city" label="Ville" outlined hide-details required />
            </v-col>
          </v-row>
          <!-- <v-col cols="12" class="py-3 px-2">
          </v-col> -->
        </v-card-text>
        <v-card-actions class="py-3 px-5">
          <v-spacer></v-spacer>
          <v-btn text @click="isOpened = false">Annuler</v-btn>
          <v-btn
            type="submit"
            color="primary darken-1"
            :loading="isSaving"
            :disabled="!$canWrite || (!canSubmit)"
          >
            Ajouter
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';

export default {
  name: `NewMakerDialog`,
  props: [`value`],
  data: () => ({
    name: ``,
    address: ``,
    postalCode: ``,
    city: ``,
    isSaving: false,
  }),
  computed: {
    ...mapState(`model/client`, [`company`]),
    isOpened: {
      get() { return this.value; },
      set(isOpened) { this.$emit(`input`, isOpened); },
    },
    canSubmit() {
      return _.trim(this.name) !== ``;
    },
  },
  methods: {
    initLocalState() {
      this.isSaving = false;
      this.name = ``;
      this.address = ``;
      this.postalCode = ``;
      this.city = ``;
    },
    async submit() {
      this.isSaving = true;
      const maker = await this.$store.dispatch(`model/client/addMakerForCompany`, {
        companyId: this.company.id,
        name: this.name,
        address: this.address,
        postalCode: this.postalCode,
        city: this.city,
      });
      this.isSaving = false;
      this.isOpened = false;
      this.$emit(`created`, maker);
    },
  },
  watch: {
    isOpened(isOpened) {
      if (isOpened) {
        this.initLocalState();
      }
    },
  },
};
</script>
